import React from 'react';
import { MemoryRouter as Router, Route, Switch } from 'react-router-dom'
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import Layout from './components/Layout';
import * as routes from './const/routes';

import Home from './screens/Home';
import Intro from './screens/Intro';

import Factory2 from './screens/Factory2';
import Factory2Building from './screens/Factory2/Factory2Building';
import Factory2Warranty from './screens/Factory2/Factory2Warranty';
import Factory2Dev from './screens/Factory2/Factory2Dev';
import Factory2Prod from './screens/Factory2/Factory2Prod';
import Factory2Trials from './screens/Factory2/Factory2Trials';

import Prod from './screens/Prod';
import Prod110 from './screens/Prod/Prod110-220';
import Prod220 from './screens/Prod/Prod330-750';
import Prod10 from './screens/Prod/Prod10-35';

import Podst from './screens/Podst';
import Podst110 from './screens/Podst/Podst110';
import Podst110_1 from './screens/Podst/Podst110_1';
import Podst110_2 from './screens/Podst/Podst110_2';
import Podst110_3 from './screens/Podst/Podst110_3';
import Podst110_4 from './screens/Podst/Podst110_4';
import Podst220 from './screens/Podst/Podst220';
import Podst330 from './screens/Podst/Podst330';
import Podst330_1 from './screens/Podst/Podst330_1';
import Podst330_2 from './screens/Podst/Podst330_2';
import Podst330_3 from './screens/Podst/Podst330_3';
import Podst330_4 from './screens/Podst/Podst330_4';

import Kooper from './screens/Kooper';
import KooperCluster from './screens/Kooper/KooperCluster';
import KooperPark from './screens/Kooper/KooperPark';
import KooperCenter from './screens/Kooper/KooperCenter';

import Project from './screens/Project';
// import ProjectLocation from './screens/Project/Location';
import ProjectLocation1 from './screens/Project/Location1';
import ProjectLocation2 from './screens/Project/Location2';
import ProjectLocation3 from './screens/Project/Location3';
import ProjectLocation4 from './screens/Project/Location4';

// const withLayout = (Component) => (props) => <Layout><Component {...props} /></Layout>

function App({location, ...props}) {
    return (
        <Router>
            <Layout>
                <Route render = { ({ location }) => (
                    <TransitionGroup style = {{height: '100%'}}>
                        <CSSTransition
                            classNames = 'routefade'
                            key = { location.key }
                            timeout = { 500 }>
                            <Switch location = { location }>
                                <Route
                                    exact
                                    component = { Intro }
                                    path = { routes.INTRO }
                                />

                                <Route
                                    exact
                                    component = { Home }
                                    path = { routes.HOME }
                                />

                                <Route
                                    exact
                                    component = { Factory2 }
                                    path = { routes.FACTORY2 }
                                />

                                <Route
                                    exact
                                    component = { Factory2Building }
                                    path = { routes.FACTORY2_BUILDING }
                                />

                                <Route
                                    exact
                                    component = { Factory2Warranty }
                                    path = { routes.FACTORY2_WARRANTY }
                                />

                                <Route
                                    exact
                                    component = { Factory2Dev }
                                    path = { routes.FACTORY2_DEV }
                                />

                                <Route
                                    exact
                                    component = { Factory2Prod }
                                    path = { routes.FACTORY2_PROD }
                                />

                                <Route
                                    exact
                                    component = { Factory2Trials }
                                    path = { routes.FACTORY2_TRIALS }
                                />

                                <Route
                                    exact
                                    component = { Prod }
                                    path = { routes.PROD }
                                />

                                <Route
                                    exact
                                    component = { Prod110 }
                                    path = { routes.PROD_110 }
                                />

                                <Route
                                    exact
                                    component = { Prod220 }
                                    path = { routes.PROD_220 }
                                />

                                <Route
                                    exact
                                    component = { Prod10 }
                                    path = { routes.PROD_330 }
                                />

                                <Route
                                    exact
                                    component = { Podst }
                                    path = { routes.PODST }
                                />

                                <Route
                                    exact
                                    component = { Podst110 }
                                    path = { routes.PODST_110 }
                                />

                                <Route
                                    exact
                                    component = { Podst110_1 }
                                    path = { routes.PODST_110_1 }
                                />

                                <Route
                                    exact
                                    component = { Podst110_2 }
                                    path = { routes.PODST_110_2 }
                                />

                                <Route
                                    exact
                                    component = { Podst110_3 }
                                    path = { routes.PODST_110_3 }
                                />
                                />

                                <Route
                                    exact
                                    component = { Podst110_4 }
                                    path = { routes.PODST_110_4 }
                                />

                                <Route
                                    exact
                                    component = { Podst220 }
                                    path = { routes.PODST_220 }
                                />

                                <Route
                                    exact
                                    component = { Podst330 }
                                    path = { routes.PODST_330 }
                                />

                                <Route
                                    exact
                                    component = { Podst330_1 }
                                    path = { routes.PODST_330_1 }
                                />

                                <Route
                                    exact
                                    component = { Podst330_2 }
                                    path = { routes.PODST_330_2 }
                                />

                                <Route
                                    exact
                                    component = { Podst330_3 }
                                    path = { routes.PODST_330_3 }
                                />
                                />

                                <Route
                                    exact
                                    component = { Podst330_4 }
                                    path = { routes.PODST_330_4 }
                                />

                                <Route
                                    exact
                                    component = { Kooper }
                                    path = { routes.KOOPER }
                                />

                                <Route
                                    exact
                                    component = { KooperCluster }
                                    path = { routes.KOOPER_CLUSTER }
                                />

                                <Route
                                    exact
                                    component = { KooperPark }
                                    path = { routes.KOOPER_PARK }
                                />

                                <Route
                                    exact
                                    component = { KooperCenter }
                                    path = { routes.KOOPER_CENTER }
                                />

                                <Route
                                    exact
                                    component = { Project }
                                    path = { routes.PROJECT } />

                                {/*<Route
                                    exact
                                    component = { ProjectLocation }
                                    path = { routes.PROJECT_LOCATION } />*/}

                                <Route
                                    exact
                                    component = { ProjectLocation1 }
                                    path = { routes.PROJECT_LOCATION_1 } />

                                <Route
                                    exact
                                    component = { ProjectLocation2 }
                                    path = { routes.PROJECT_LOCATION_2 } />

                                <Route
                                    exact
                                    component = { ProjectLocation3 }
                                    path = { routes.PROJECT_LOCATION_3 } />

                                <Route
                                    exact
                                    component = { ProjectLocation4 }
                                    path = { routes.PROJECT_LOCATION_4 } />
                            </Switch>
                        </CSSTransition>
                    </TransitionGroup>
                ) } />
            </Layout>
        </Router>
    );
}

export default App;
